/* eslint-disable no-console */
import { client } from "."; // ← el cliente oficial de Supabase

// PostgREST recorta cada response a `max-rows` (2000 en este proyecto). Una sola query
// `.order("id", desc).limit(5000)` NO sube ese techo: al superar la tabla las 2000 filas
// habilitadas quedaban afuera los ids más chicos (id=1 Ignacio, 2/3/4/7…), y todo consumidor
// que resuelve usuarios por id los veía como "??"/vacío. Paginamos con .range() en bloques
// para traer el universo completo, sin depender del cap del server. Orden descendente
// preservado (mismo contrato que antes; el orden no depende del recorte porque traemos todo).
const PAGE_SIZE = 1000;

export const getUsers = async ({ includeDisabled = false } = {}) => {
  try {
    const usuarios = [];
    for (let desde = 0; ; desde += PAGE_SIZE) {
      let query = client.from("usuarios").select("*");

      // Por defecto se excluyen los suspendidos (cero regresión para otros consumidores).
      // includeDisabled === true los incluye (solo admins en Usuarios/index.js).
      if (!includeDisabled) {
        query = query.neq("habilitado", false);
      }

      const { data, error } = await query.order("id", { ascending: false }).range(desde, desde + PAGE_SIZE - 1);

      if (error) throw error;
      if (!data || data.length === 0) break;

      usuarios.push(...data);
      if (data.length < PAGE_SIZE) break; // última página (devolvió menos que el bloque)
    }

    return usuarios;
  } catch (error) {
    console.error("Error en getUsers:", error);
    return [];
  }
};
